module.exports = __webpack_public_path__ + "img/slide.4565b69c.jpg";